import { useEffect, useRef } from 'react';

const modalStack = [];
let nextModalId = 1;

function removeModal(id) {
  const index = modalStack.findIndex((item) => item.id === id);
  if (index >= 0) modalStack.splice(index, 1);
}

export default function useModalEscape(active, onEscape) {
  const idRef = useRef(0);
  const onEscapeRef = useRef(onEscape);

  useEffect(() => {
    onEscapeRef.current = onEscape;
  }, [onEscape]);

  useEffect(() => {
    if (!active) return undefined;
    if (!idRef.current) {
      idRef.current = nextModalId;
      nextModalId += 1;
    }

    const id = idRef.current;

    function handleKeyDown(event) {
      if (event.key !== 'Escape') return;
      const topModal = modalStack[modalStack.length - 1];
      if (topModal?.id !== id) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation?.();
      event.nativeEvent?.stopImmediatePropagation?.();
      onEscapeRef.current?.(event);
    }

    removeModal(id);
    modalStack.push({ id });
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      removeModal(id);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [active]);
}
